import React from "react";
import "./ProgramSectionHeader.css";

const ProgramSectionHeader = ({
  kicker,
  title,
  titleAccent,
  id,
  size = "default",
}) => (
  <header
    className={`program-section-header program-section-header--${size}`}
    aria-labelledby={id}
  >
    {kicker && <p className="program-section-header__kicker">{kicker}</p>}
    <h2 id={id} className="program-section-header__title">
      {title}
      {titleAccent && (
        <>
          {" "}
          <span className="program-section-header__accent">{titleAccent}</span>
        </>
      )}
    </h2>
  </header>
);

export default ProgramSectionHeader;
